// @vue/component
export default {
  name: 'ConversationContentBox',

  props: {
    typeDirection: {
      type: String,
      default: 'right',
    },
  },
};
